export const BoltLandingIcon = ({ color = '#364bf3', ...props }) => (
  <svg
    width={'196.62mm'}
    height={'197.03mm'}
    version={'1.1'}
    viewBox={'0 0 196.62 197.03'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <defs>
      <filter
        id={'filter0_d_51_11491'}
        x={'.25822'}
        y={'.7902'}
        width={'132.74'}
        height={'166.35'}
        colorInterpolationFilters={'sRGB'}
        filterUnits={'userSpaceOnUse'}
      >
        <feFlood
          floodOpacity={'0'}
          result={'BackgroundImageFix'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset dy={'23.032'} />
        <feGaussianBlur stdDeviation={'18.4256'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 0.113438 0 0 0 0 0.113438 0 0 0 0 0.1375 0 0 0 0.16 0'} />
        <feBlend
          in2={'BackgroundImageFix'}
          result={'effect1_dropShadow_51_11491'}
        />
        <feBlend
          in={'SourceGraphic'}
          in2={'effect1_dropShadow_51_11491'}
          result={'shape'}
        />
      </filter>
      <linearGradient
        id={'paint0_linear_51_11491'}
        x1={'66.63'}
        x2={'66.63'}
        y1={'14.609'}
        y2={'107.26'}
        gradientUnits={'userSpaceOnUse'}
      >
        <stop
          stopColor={color}
          offset={'0'}
        />
        <stop
          stopColor={color}
          offset={'1'}
        />
      </linearGradient>
      <filter
        id={'filter0_ddii_51_11489'}
        x={'.60755'}
        y={'.98255'}
        width={'288.83'}
        height={'288.83'}
        colorInterpolationFilters={'sRGB'}
        filterUnits={'userSpaceOnUse'}
      >
        <feFlood
          floodOpacity={'0'}
          result={'BackgroundImageFix'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-10.7506'}
          dy={'10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 0.0359722 0 0 0 0 0.0477917 0 0 0 0 0.154167 0 0 0 0.08 0'} />
        <feBlend
          in2={'BackgroundImageFix'}
          result={'effect1_dropShadow_51_11489'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'10.7506'}
          dy={'-10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect1_dropShadow_51_11489'}
          result={'effect2_dropShadow_51_11489'}
        />
        <feBlend
          in={'SourceGraphic'}
          in2={'effect2_dropShadow_51_11489'}
          result={'shape'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-10.7506'}
          dy={'10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 0.0352941 0 0 0 0 0.0470588 0 0 0 0 0.152941 0 0 0 0.08 0'} />
        <feBlend
          in2={'shape'}
          result={'effect3_innerShadow_51_11489'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'10.7506'}
          dy={'-10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect3_innerShadow_51_11489'}
          result={'effect4_innerShadow_51_11489'}
        />
      </filter>
      <filter
        id={'filter0_ddii_51_11488'}
        x={'.2599'}
        y={'-6.5096'}
        width={'494.9'}
        height={'494.9'}
        colorInterpolationFilters={'sRGB'}
        filterUnits={'userSpaceOnUse'}
      >
        <feFlood
          floodOpacity={'0'}
          result={'BackgroundImageFix'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-10.7506'}
          dy={'10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 0.0359722 0 0 0 0 0.0477917 0 0 0 0 0.154167 0 0 0 0.08 0'} />
        <feBlend
          in2={'BackgroundImageFix'}
          result={'effect1_dropShadow_51_11488'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'10.7506'}
          dy={'-10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect1_dropShadow_51_11488'}
          result={'effect2_dropShadow_51_11488'}
        />
        <feBlend
          in={'SourceGraphic'}
          in2={'effect2_dropShadow_51_11488'}
          result={'shape'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-10.7506'}
          dy={'10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 0.0352941 0 0 0 0 0.0470588 0 0 0 0 0.152941 0 0 0 0.08 0'} />
        <feBlend
          in2={'shape'}
          result={'effect3_innerShadow_51_11488'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'10.7506'}
          dy={'-10.7506'}
        />
        <feGaussianBlur stdDeviation={'10.7506'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect3_innerShadow_51_11488'}
          result={'effect4_innerShadow_51_11488'}
        />
      </filter>
      <filter
        id={'filter0_ddii_51_11487'}
        x={'.14216'}
        y={'-132.18'}
        width={'743.15'}
        height={'744.68'}
        colorInterpolationFilters={'sRGB'}
        filterUnits={'userSpaceOnUse'}
      >
        <feFlood
          floodOpacity={'0'}
          result={'BackgroundImageFix'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-18.3068'}
          dy={'18.3068'}
        />
        <feGaussianBlur stdDeviation={'18.3068'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 0.0359722 0 0 0 0 0.0477917 0 0 0 0 0.154167 0 0 0 0.08 0'} />
        <feBlend
          in2={'BackgroundImageFix'}
          result={'effect1_dropShadow_51_11487'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'18.3068'}
          dy={'-18.3068'}
        />
        <feGaussianBlur stdDeviation={'18.3068'} />
        <feComposite
          in2={'hardAlpha'}
          operator={'out'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect1_dropShadow_51_11487'}
          result={'effect2_dropShadow_51_11487'}
        />
        <feBlend
          in={'SourceGraphic'}
          in2={'effect2_dropShadow_51_11487'}
          result={'shape'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'-18.3068'}
          dy={'18.3068'}
        />
        <feGaussianBlur stdDeviation={'18.3068'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 0.0352941 0 0 0 0 0.0470588 0 0 0 0 0.152941 0 0 0 0.08 0'} />
        <feBlend
          in2={'shape'}
          result={'effect3_innerShadow_51_11487'}
        />
        <feColorMatrix
          in={'SourceAlpha'}
          result={'hardAlpha'}
          values={'0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'}
        />
        <feOffset
          dx={'18.3068'}
          dy={'-18.3068'}
        />
        <feGaussianBlur stdDeviation={'18.3068'} />
        <feComposite
          in2={'hardAlpha'}
          k2={'-1'}
          k3={'1'}
          operator={'arithmetic'}
        />
        <feColorMatrix values={'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'} />
        <feBlend
          in2={'effect3_innerShadow_51_11487'}
          result={'effect4_innerShadow_51_11487'}
        />
      </filter>
    </defs>
    <g transform={'translate(-6.688 -44.549)'}>
      <g fill={'none'}>
        <g transform={'matrix(.26458 0 0 .26458 87.371 126.28)'}>
          <path
            d={'m67.723 71.306-4.3733 35.949 32.8-61.216-28.427 2.2597 4.3734-33.689-34.987 58.956z'}
            fill={'url(#paint0_linear_51_11491)'}
            filter={'url(#filter0_d_51_11491)'}
          />
        </g>
        <g transform={'matrix(.26458 0 0 .26458 66.629 104.74)'}>
          <circle
            cx={'145.02'}
            cy={'145.4'}
            r={'112.16'}
            fill={'#fff'}
            fillOpacity={'.01'}
            filter={'url(#filter0_ddii_51_11489)'}
            opacity={'.5'}
            shapeRendering={'crispEdges'}
          />
        </g>
        <g transform={'matrix(.26458 0 0 .26458 39.459 78.703)'}>
          <circle
            cx={'247.71'}
            cy={'240.94'}
            r={'215.2'}
            fill={'#fff'}
            fillOpacity={'.01'}
            filter={'url(#filter0_ddii_51_11488)'}
            opacity={'.25'}
            shapeRendering={'crispEdges'}
          />
        </g>
        <g transform={'matrix(.26458 0 0 .26458 6.6504 79.521)'}>
          <ellipse
            cx={'371.72'}
            cy={'240.16'}
            rx={'316.65'}
            ry={'317.42'}
            fill={'#fff'}
            fillOpacity={'.01'}
            filter={'url(#filter0_ddii_51_11487)'}
            opacity={'.08'}
            shapeRendering={'crispEdges'}
          />
        </g>
      </g>
    </g>
  </svg>

);
